export enum DPFormFieldType {
  SingleLine = 1,
  MultiLine,
  Dropdown,
  Checkbox,
  Radio,
  Date,
  Multivalue,
  TextBlock,
  Address,
  State,
  YesNo,
  StartEndDate,
  None,
}
